import { COUPON_ITEM } from "@src/mock/data/coupon";

export default {
  title: '檢查會員優惠券',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": COUPON_ITEM,
        }
      }
    },
  ]
}
